module.exports = __webpack_public_path__ + "static/fourpcanimalmain-fd3a9034b182073161dbe9f9e76738d9.jpeg";